export const STICKY_BAR_ID = 'room-details-sticky-bar';

export enum RoomRateFormStepNames {
  GUESTS = 'guestDetailsStep',
  EXTRAS = 'extras',
}

export const isInlineBookingStep = (bookingStep: string | undefined, isMultiRoom: boolean) =>
  !isMultiRoom &&
  (bookingStep === RoomRateFormStepNames.GUESTS || bookingStep === RoomRateFormStepNames.EXTRAS);
